import React from "react";

interface PartnerTagViewProps {
  tags?: string[] | { tag: string }[];
}

const PartnerTagView: React.FC<PartnerTagViewProps> = ({ tags }) => {
  if (!tags || tags.length === 0) return <span className="text-gray-500">-</span>;

  const getTagClasses = (tag: string) => {
    switch (tag.toUpperCase()) {
      case "FTL":
        return "bg-blue-100 text-blue-700";
      case "LTL":
        return "bg-green-100 text-green-700";
      case "AIR":
        return "bg-purple-100 text-purple-700";
      case "FCL":
        return "bg-yellow-100 text-yellow-700";
      default:
        return "bg-gray-200 text-gray-700";
    }
  };

  const getTagText = (tagItem: string | { tag: string }): string => {
    return typeof tagItem === "string" ? tagItem : tagItem.tag;
  };

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tagItem, index) => {
        const tagText = getTagText(tagItem);
        return (
          <span
            key={`${tagText}-${index}`}
            className={`px-2 py-0.5 text-xs font-semibold rounded ${getTagClasses(tagText)}`}
          >
            {tagText}
          </span>
        );
      })}
    </div>
  );
};

export default PartnerTagView;
